module.exports = __webpack_public_path__ + "media/images/lp/main-683e43d67087036e13c68855d4be4025.png";